export default __webpack_public_path__ + "static/media/whatsapp.b1b801cf.png";